import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

const Login = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/?url=admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem("admin_token", data.token);
        navigate("/dashboard");
      } else {
        setError(data.error || "Login failed");
      }
    } catch {
      setError("Could not connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0f2f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: 420, padding: "0 16px" }}>

        {/* Card */}
        <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", overflow: "hidden" }}>

          {/* Header strip */}
          <div style={{ background: "#1a1a1a", padding: "32px 40px 28px", textAlign: "center" }}>
            <div style={{ display: "inline-flex", background: "#fff", borderRadius: 10, padding: "8px 16px", marginBottom: 14 }}>
            <img
              src="/images/clean_logo.png"
              alt="Clear & Clean"
              style={{ height: 44, objectFit: "contain", display: "block" }}
              onError={(e) => { e.target.parentElement.style.display = "none"; }}
            />
          </div>
            <h5 style={{ color: "#fff", margin: 0, fontWeight: 700, fontSize: 18, letterSpacing: 0.3 }}>
              Admin Portal
            </h5>
            <p style={{ color: "#aaa", margin: "4px 0 0", fontSize: 13 }}>
              Clear &amp; Clean — Christchurch
            </p>
          </div>

          {/* Form */}
          <div style={{ padding: "32px 40px 36px" }}>
            {error && (
              <div style={{
                background: "#fff5f5", border: "1px solid #fca5a5", color: "#b91c1c",
                borderRadius: 8, padding: "10px 14px", marginBottom: 20, fontSize: 14, display: "flex", alignItems: "center", gap: 8
              }}>
                <i className="fa fa-exclamation-circle" />
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {/* Username */}
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
                  Username
                </label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-user" style={{ position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", fontSize: 14 }} />
                  <input
                    type="text"
                    value={form.username}
                    onChange={(e) => setForm({ ...form, username: e.target.value })}
                    required
                    autoFocus
                    placeholder="Enter username"
                    style={{
                      width: "100%", padding: "10px 12px 10px 36px", border: "1.5px solid #e5e7eb",
                      borderRadius: 8, fontSize: 14, outline: "none", boxSizing: "border-box",
                      transition: "border-color .2s"
                    }}
                    onFocus={(e) => e.target.style.borderColor = "#1a1a1a"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                </div>
              </div>

              {/* Password */}
              <div style={{ marginBottom: 26 }}>
                <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
                  Password
                </label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-lock" style={{ position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", fontSize: 14 }} />
                  <input
                    type={showPw ? "text" : "password"}
                    value={form.password}
                    onChange={(e) => setForm({ ...form, password: e.target.value })}
                    required
                    placeholder="Enter password"
                    style={{
                      width: "100%", padding: "10px 40px 10px 36px", border: "1.5px solid #e5e7eb",
                      borderRadius: 8, fontSize: 14, outline: "none", boxSizing: "border-box",
                      transition: "border-color .2s"
                    }}
                    onFocus={(e) => e.target.style.borderColor = "#1a1a1a"}
                    onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPw(!showPw)}
                    style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9ca3af", padding: 0 }}
                  >
                    <i className={`fa ${showPw ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: 14 }} />
                  </button>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: "100%", padding: "11px", background: loading ? "#555" : "#1a1a1a",
                  color: "#fff", border: "none", borderRadius: 8, fontWeight: 600,
                  fontSize: 15, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 0.3,
                  transition: "background .2s"
                }}
              >
                {loading ? (
                  <span><span className="spinner-border spinner-border-sm me-2" />Signing in…</span>
                ) : "Sign In"}
              </button>
            </form>
          </div>
        </div>

        <p style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: "#9ca3af" }}>
          &copy; {new Date().getFullYear()} Clear &amp; Clean. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Login;
